module.exports = __webpack_public_path__ + "img/banner.5f40271f.png";